import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import {Link} from "react-router-dom";
import LinkOffIcon from '@material-ui/icons/LinkOff';
import Progress from "../../../../../../ui/Progress";

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
  },
  avatar: {
    backgroundColor:"#f44336",
  },
});

const InfoCard = ({title, subheader, action, iconColor="#f44336",
                    contentTitle,
                    contentBody,
                    cardActions,
                    linkTo,
                    disabled,
                    loading,
                  icon}) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      {loading ? <Progress/> : <>
      <CardActionArea>
        <CardHeader
          avatar={
            <Avatar aria-label="recipe" style={{backgroundColor: iconColor}}>
              {icon}
            </Avatar>
          }
          action={action}
          title={title}
          subheader={subheader}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {linkTo ?
            <Link className={classes.link}
                  target="_blank"
                  title="Открыть в новой вкладке"
                  key={linkTo}
                  to={linkTo}>
              {contentTitle}
            </Link> : <>{contentTitle}</>}
          </Typography>
          <div>
            {contentBody}
          </div>
        </CardContent>
      </CardActionArea>
        {cardActions && cardActions.length > 0 &&
      <CardActions>{cardActions.map(({label, onClick, disabled}) => (
        <Button key={label} disabled={disabled} size="small" color="primary" onClick={onClick}>
          {label}
        </Button>
      ))}
      </CardActions>}</>}
    </Card>
  )
}

export default InfoCard;
